export default __webpack_public_path__ + "static/media/lightning.b74d8d48.svg";